module.exports = __webpack_public_path__ + "static/mini_rose-e3d1fdb19eaf8fb6ec0fbb88b80edb7d.jpg";